import ButtonSubmit from '../ui/ButtonSubmit'
import { useNavigate } from 'react-router-dom';
import { ImageTemp, InitialPallets, InitialReport, MainData, GGNLocations } from '../../interfaces/intakes.reports';
import toast from 'react-hot-toast';
import { formatSplit, totalSamples } from '../../helpers/formatSplit'
import { palletData } from '../../data/pallet-steps'
import { Fruit } from '../../interfaces/interfaces';
import { useFetchInitialReport } from '../../api/useInitialReport';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useWeather } from '../../hooks/useWeather';
import { useEffect, useState } from 'react';
import { Grower } from '../../interfaces/interfaces.auth';
import { City } from '../../interfaces/weather.types';

interface Props {
    mainData: MainData
    team: string | null
    supplier: string | null
    fruit: Fruit | null
    batchImages: ImageTemp[]
}

const CreateButtonReport = ({ mainData, team, supplier, fruit, batchImages }: Props) => {

    const navigate = useNavigate();
    const { mutate, isLoading } = useFetchInitialReport()
    const { settings, growers, uid } = useTypedSelector(state => state.auth);
    const [growersList, setGrowersList] = useState<Grower[]>([])
    const { loading: isLoadingWeather, fetchWeatherData } = useWeather()

    useEffect(() => {
        if (team) setGrowersList(growers.find(grower => grower.id === team)?.growers || [])
        else setGrowersList(growers.find(grower => grower.id === uid)?.growers || [])
    }, [team, growers, uid])

    const saveInitialReport = async () => {

        if (!mainData?.pallet_ref) return toast.error("Please add a pallet reference")

        let fetchPallets: InitialPallets[] = []

        if (+mainData?.total_pallets >= 1 && +mainData?.total_pallets <= 30) {
            for (let index = 0; index < Number(mainData?.total_pallets); index++) {
                fetchPallets.push(palletData(
                    fruit as Fruit,
                    (totalSamples(mainData?.format) || +mainData?.samples || 1),
                    (formatSplit(mainData?.format) || 1),
                    index + 1,
                    settings
                ))
            }
        } else {
            fetchPallets.push(palletData(
                fruit as Fruit,
                (totalSamples(mainData?.format) || +mainData?.samples || 1),
                (formatSplit(mainData?.format) || 1),
                1,
                settings
            ))
        }

        // Tomar el weather de los GGN
        const takeGGNDataforWeather = async (): Promise<GGNLocations[]> => {
            
            const harvestDate = mainData?.harvest_day || mainData?.loading_day
            
            if (!harvestDate || !mainData?.ggn) return []

            const ggnExist = mainData.ggn.split(",").filter((ggn: string) => growersList.find(grower => grower.ggn_number === ggn.trim())) || []

            if (ggnExist.length === 0) return []

            const newCity: City[] = ggnExist.map((ggn: string) => {

                const findedGGN: Grower | undefined = growersList.find(grower => grower.ggn_number === ggn.trim())

                if (findedGGN) {
                    return {
                        ggn_number: findedGGN.ggn_number,
                        city: findedGGN.fields[0].city,
                        country: findedGGN.fields[0].country,
                        latitude: findedGGN.fields[0].coords.lat,
                        longitude: findedGGN.fields[0].coords.lon,
                        date: harvestDate
                    }
                }
            })

            const data = await fetchWeatherData(newCity)

            if (!data || data.length === 0) { return [] }

            const ggnLocation: GGNLocations[] = data.map(location => (
                {
                    harvest_day: harvestDate,
                    ggn_number: location.ggn_number || '',
                    city: location.city.trim() || "",
                    country: location.country.trim() || '',
                    quantity: 0,
                    coords: { lat: location.latitude, lon: location.longitude },
                    historical: data.find(d => d.city === location.city)?.historical || []
                }
            ))
            return ggnLocation.every( loc => loc.ggn_number ) ? ggnLocation : []
        };

        const fetchData: InitialReport = {
            mainData,
            fruit: fruit as Fruit,
            supplier,
            team,
            pallets: fetchPallets,
            weather: await takeGGNDataforWeather(),
            mainDataImages: batchImages
        }

        mutate(fetchData, {
            onSuccess: async (data) => {
                navigate(`/create-report/${data.reportId}`)
            },
            onError: () => toast.error("Something went wrong, please try again later")
        })
    };

    return (
        <>
            <ButtonSubmit
                center
                title='Start Report'
                action={saveInitialReport}
                color="green"
                isLoading={isLoading || isLoadingWeather}
            />
        </>
    )
}

export default CreateButtonReport